import React from "react";

const PerformanceGate = React.lazy(() => import("./Performance.gate"));

const PerformanceLoadable = () => <PerformanceGate />;

export default () => <PerformanceLoadable />;
